var map = {
	"./connect.png": "657e",
	"./contacts.png": "e9c8",
	"./corona.png": "87c6",
	"./dbase.png": "207e",
	"./engine.png": "6901",
	"./gamepad.png": "3419",
	"./light.png": "b448",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./mobile.png": "978f",
	"./music.png": "40be",
	"./music2.png": "d4d5",
	"./oven.png": "f6af",
	"./oven2.png": "00a0",
	"./pacghost.png": "6100",
	"./pacman.png": "c1b1",
	"./team.png": "21e1",
	"./team2.png": "3c06",
	"./tech.png": "8a13",
	"./test.png": "1552",
	"./world.png": "47de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";